// One place for how the hub watches provisioning, shared by the org-address probe
// (useHostReady) and the product readiness poll (useGuardianReadiness) so the pacing
// is tuned once. The lifecycle: poll eagerly while success is expected, slow down once
// it's overdue (the copy turns apologetic but checking continues), and stop entirely
// when something is clearly wrong — from there a refresh starts a fresh session.
export const PROVISIONING_POLL_INTERVAL_MS = 3_000;
// A new org's address needs its own Let's Encrypt cert (DNS-01), usually ~10 minutes;
// 15 gives headroom so the apologetic copy only shows on a genuine overrun.
export const PROVISIONING_POLL_PATIENCE_MS = 900_000;
export const PROVISIONING_POLL_SLOW_INTERVAL_MS = 30_000;
export const PROVISIONING_POLL_GIVE_UP_MS = 1_800_000;
